import { Theme } from "@remo-co/ui-core/src/types";
import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

export const useStyles = makeStyles<Theme>((theme) => ({
  pollNotification: {
    display: "flex",
    flexDirection: "column",
    alignItems: "start",
    justifyContent: "start",
    gap: 10,
    paddingLeft: 10,
    width: 242,
  },
  pollNotificationContent: {
    display: "flex",
    justifyContent: "start",
    alignItems: "center",
    gap: 10,
  },
  notificationButton: {
    width: 101,
    height: 28,
    left: 180,
  },
  pollsIconContainer: {
    width: 30,
    height: 30,
    borderRadius: "50%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: theme.palette.events.blueShade2,
  },
  pollsIcon: {
    color: theme.palette.events.bluePrimary,
    height: 22,
    width: 22,
  },
}));
